import { render, staticRenderFns } from "./Create-permission.vue?vue&type=template&id=7a9854ac&scoped=true"
import script from "./Create-permission.vue?vue&type=script&lang=js"
export * from "./Create-permission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9854ac",
  null
  
)

export default component.exports